<template>
  <div :class="['result', 'row', {'row--light': !showRelationshipForm }]">
    <div class="result__wrapper">
      <img
        :src="picture"
        class="result__image"
        @error="handleInvalidProfilePicture"
      >
      <p
        class="result__text"
        tabindex="0"
        @click="toggleRelationshipForm"
        @keyup.enter="toggleRelationshipForm"
      >
        <span class="result__text--title">{{ titleAbbreviation }}</span>
        <span class="result__text--name">{{ firstName }} {{ lastName }}</span>
        <span class="result__text--party">{{ party }}</span>
      </p>
      <i
        v-show="complete"
        class="success">
        <icon
          icon-name="check"
          view-box="0 0 24 24"/>
      </i>
      <icon
        v-show="!complete"
        :class="['toggle', {'closed': !showRelationshipForm}]"
        icon-name="x"
        view-box="0 0 24 24"
        tabindex="0"
        @click.native="toggleRelationshipForm"
        @keyup.native.enter="toggleRelationshipForm"/>
    </div>
    <relationship-form
      v-if="showRelationshipForm"
      :id="id"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import Icon from "StyleguideComponents/Icon.vue";
import AccordionTransition from "Assets/js/transitions/whodoyouknow/AccordionTransition.vue";
import RelationshipForm from "WhoDoYouKnowComponents/forms/RelationshipForm.vue";
import { isEmpty as _isEmpty } from "lodash";

export default {
  name: "Stakeholder",
  inject: {
    stakeholderService: { from: "stakeholderService" },
    eventsBus: { from: "eventsBus" }
  },
  components: {
    AccordionTransition,
    RelationshipForm,
    Icon
  },
  props: {
    id: {
      type: Number,
      required: true
    },
    firstName: {
      type: String,
      required: true
    },
    lastName: {
      type: String,
      required: true
    },
    partyAbbreviation: {
      type: String,
      default: ""
    },
    stateAbbreviation: {
      type: String,
      default: ""
    },
    titleAbbreviation: {
      type: String,
      required: true
    },
    profilePicture: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      picture: this.profilePicture,
      showRelationshipForm: false
    };
  },
  computed: {
    ...mapState("campaign", {
      stakeholderDefaultPhotoUrl: state => state.stakeholderDefaultPhotoUrl
    }),
    ...mapState("wdyk", {
      relationships: state => state.relationships
    }),
    complete() {
      return this.relationships.indexOf(this.id) !== -1;
    },
    party() {
      const parts = [];

      if (!_isEmpty(this.partyAbbreviation)) {
        parts.push(this.partyAbbreviation);
      }

      if (!_isEmpty(this.stateAbbreviation)) {
        parts.push(this.stateAbbreviation);
      }

      if (!_isEmpty(parts)) {
        return `(${parts.join("-")})`;
      }

      return "";
    }
  },
  mounted() {
    this.eventsBus.$on("clearRelationshipForm", () => {
      this.showRelationshipForm = false;
    });

    if (_isEmpty(this.picture)) {
      this.handleInvalidProfilePicture();
    }
  },
  methods: {
    handleInvalidProfilePicture() {
      this.picture = this.stakeholderDefaultPhotoUrl;
    },
    toggleRelationshipForm() {
      if (!this.complete && !this.showRelationshipForm) {
        this.stakeholderService.clearStakeholderErrors();
        this.eventsBus.$emit("clearRelationshipForm");
        this.eventsBus.$emit("showRelationshipForm", true);
        this.showRelationshipForm = true;
      } else {
        this.eventsBus.$emit("showRelationshipForm", false);
        this.showRelationshipForm = false;
      }
    }
  }
};
</script>
